/* ============================================================
   Kabelkonfigurator – Bindung im Warenkorb (30.09.2026)

   Zeilen eines konfektionierten Kabels tragen die versteckten
   Eigenschaften _kk (Kennung je Kabel, z. B. "K-7F3A-1") und
   _kk_rolle ("leitung", "konf", "sich", "halter").
   snippets/cart-item.liquid zeigt bei diesen Zeilen keinen Mengen-
   zaehler und den Loeschknopf nur an der Leitung.

   Dieses Skript raeumt auf: Fehlt zu einer Kennung die Leitung
   (entfernt oder nie vorhanden), werden alle uebrigen Zeilen dieser
   Kennung entfernt — Pauschale, Zuschlaege, Sicherung, Halter.

   08.10.2026, Vorgabe Auftraggeber: Der Bestellhinweis bleibt frei vom
   Kabelkonfigurator. Bis 30.09.2026 haengte der Konfigurator Zeilen an
   die Notiz an, die in alten Warenkoerben stehen bleiben. Entfernt werden
   NUR diese Zeilen (istKKZeile), Text des Kunden bleibt stehen:
     - "Kabelkonfigurator – gewaehlte Anschluesse ..." (alter Teil 1)
     - "Kabel 1 (6 mm², 5 m, rot): ... (Ende A); ..." (alter Teil 2)
   Faengt auch jeden kuenftigen Schreibversuch ab, weil das Skript nach
   jedem /cart/update laeuft.

   Ausgeloest wird es beim Laden und nach JEDER Warenkorb-Aenderung
   (/cart/change, /cart/update), egal von welchem Skript sie kommt —
   dafuer wird window.fetch umhuellt. Eigene Aufrufe laufen ueber das
   Original-fetch und loesen deshalb nichts erneut aus. Frueher hing das
   am pubsub-Ereignis des Themes; auf der Warenkorb-Seite wurde das
   Skript aber gar nicht geladen (dort rendert theme.liquid keinen
   Drawer). Geladen wird es jetzt aus snippets/cart-drawer.liquid und
   sections/main-cart-items.liquid.
   Rechnet nichts, fuegt nichts hinzu.
   ============================================================ */
(function () {
  "use strict";
  if (window.__kkBindung) { return; }
  window.__kkBindung = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var ORIG = window.fetch ? window.fetch.bind(window) : null;
  var laeuft = false, nochmal = false;
  if (!ORIG) { return; }

  function waisen(items) {
    var g = {};
    (items || []).forEach(function (it) {
      var p = it.properties || {}, id = p._kk;
      if (!id) { return; }
      if (!g[id]) { g[id] = { leitung: false, keys: [] }; }
      if (p._kk_rolle === "leitung") { g[id].leitung = true; }
      g[id].keys.push(it.key);
    });
    var updates = {}, n = 0;
    Object.keys(g).forEach(function (id) {
      if (g[id].leitung) { return; }
      g[id].keys.forEach(function (k) { updates[k] = 0; n++; });
    });
    return n ? updates : null;
  }

  /* 08.10.2026: Zeilen, die der Kabelkonfigurator geschrieben hat */
  var KK_T1 = /^Kabelkonfigurator\s*[\u2013\u2014-]/;
  var KK_T2 = /^Kabel \d+ \([^()]*mm²[^()]*\):.*\(Ende [AB]\)/;
  function istKKZeile(z) { var t = String(z).trim(); return KK_T1.test(t) || KK_T2.test(t); }
  /* Liefert die bereinigte Notiz oder null, wenn nichts zu tun ist */
  function notizOhneKK(note) {
    if (!note) { return null; }
    var zeilen = String(note).split(/\r?\n/);
    var rest = zeilen.filter(function (z) { return !istKKZeile(z); });
    if (rest.length === zeilen.length) { return null; }
    return rest.join("\n").replace(/\n{3,}/g, "\n\n").replace(/^\s+|\s+$/g, "");
  }
  /* Offene Notizfelder nachziehen — nur wenn dort noch der alte Text steht,
     damit nichts ueberschrieben wird, was der Kunde gerade tippt */
  function notizfelder(alt, neu) {
    document.querySelectorAll('textarea[name="note"]').forEach(function (t) {
      if (String(t.value).trim() === String(alt).trim()) { t.value = neu; }
    });
  }

  function neuZeichnen() {
    var aufWarenkorb = !!document.getElementById("main-cart-items");
    if (aufWarenkorb) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
  }

  function pruefe() {
    if (laeuft) { nochmal = true; return; }
    laeuft = true;
    ORIG(ROOT + "cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = waisen(cart && cart.items);
        var note = notizOhneKK(cart && cart.note);
        if (!updates && note === null) { return null; }
        var body = {};
        if (updates) { body.updates = updates; }
        if (note !== null) { body.note = note; }
        return ORIG(ROOT + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) { return; }
          if (note !== null) { notizfelder(cart.note, note); }
          if (updates) { neuZeichnen(); }
        });
      })
      .catch(function () {})
      .then(function () {
        laeuft = false;
        if (nochmal) { nochmal = false; pruefe(); }
      });
  }

  var AENDERUNG = /\/cart\/(change|update)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = ORIG(input, init);
    if (AENDERUNG.test(url)) { p.then(function () { setTimeout(pruefe, 80); }, function () {}); }
    return p;
  };

  window.__kkWaisen = waisen; /* fuer Tests */
  window.__kkNotiz = notizOhneKK; /* fuer Tests */
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", pruefe); } else { pruefe(); }
})();
